export class YesNo {
    static options() {
        return [
            {
                value: 'yes',
                text: 'Yes'
            },
            {
                value: 'no',
                text: 'No'
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/helpers/yes-no-options.js